import CuentaShow from './CuentaShow'
export {CuentaShow}
export default CuentaShow
